import React, {Component} from 'react'
import Slider from 'react-slick'

import {v1 as uuidv1} from 'uuid'

import style from './resultSlider.module.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './slider-styles.css'

class ResultSlider extends Component {

   render() {
      const {settings, images} = this.props
      return (
         <Slider {...settings} className={style.resultSlider__slider}>
            {images.map((image, i) => (
               <div className={style.resultSlider__photoItem} key={uuidv1()}>
                  <img className={style.resultSlider__photo} src={image.url} alt={image.title} />
               </div>
            ))}
         </Slider>
      )
   }
}

export default ResultSlider